import { createFileRoute } from '@tanstack/react-router';
import { JourneysBroadcastMetricsHandoff } from '@/pages/workspaces/broadcasts/broadcast/routing';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/broadcasts/broadcast/$broadcastId/overview/metrics',
)({
  component: JourneysBroadcastMetricsHandoff,
});
